export const accountMovement = {
  accountMovementTransaction: "Transaksie",
  accountMovementAmount: "Bedrag",
  accountMovementDeposit: "Deposito's",
  accountMovementTransfer: "Oordragte",
  accountMovementBet: "Weddenskappe",
  accountMovementWithdrawal: "Onttrekkings",
  accountMovementBonus: "Bonusse",
  movementsBtnBack: "Terug",
  accountMovementBetAll: "Almal",
  accountMovementBetWon: "Gewen",
  accountMovementBetLost: "Verloor",
  movementsDepositDesc: "Geskiedenis van deposito's wat op jou rekening gemaak is",
  movementsTransferDesc: "Oordragte gestuur en ontvang tussen gebruikers",
  movementsBetDesc: "Opsomming van weddenskappe geplaas en uitslae",
  movementsWithdrawalDesc: "Geskiedenis van verwerkte onttrekkings",
  movementsBonusDesc: "Bonusse en promosies ontvang",
  movementsTransferReceived: "Ontvang",
  movementsTransferSent: "Gestuur",
  movementsTotalBets: "Totale weddenskappe",
  movementsTotalWins: "Totale winste",
  movementsNetResult: "Netto resultaat",
  movementsLoadMore: "Laai meer",
  movementsEmptyTitle: "Geen transaksies",
  movementsEmptyDesc: "Jy het nog geen transaksies in hierdie kategorie nie",
  paginationItemsPerPage: "/ bladsy",
  paginationJumpTo: "Gaan na",
  paginationJumpToConfirm: "bevestig",
  paginationPage: "Bladsy",
  paginationPrevPage: "Vorige bladsy",
  paginationNextPage: "Volgende bladsy",
  paginationPrev5: "Vorige 5 bladsye",
  paginationNext5: "Volgende 5 bladsye",
  paginationPrevPageTooltip: "Vorige bladsy",
  paginationNextPageTooltip: "Volgende bladsy",
  paginationOf: "van",
  paginationItems: "items",
};
